import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 19.664 18.259"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", {
  id: "home_filled",
  transform: "translate(-1.5 -2.25)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_2481",
    d: "M11.332 2.25 1.5 12.082h2.809V19.1a1.405 1.405 0 0 0 1.4 1.4h2.463v-4.265a2.048 2.048 0 0 1 2.046-2.046h2.229a2.048 2.048 0 0 1 2.046 2.046v4.275h2.457a1.405 1.405 0 0 0 1.4-1.4v-7.028h2.809z",
    class: "cls-1"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_2482",
    d: "M13 16.5h-2.234a.641.641 0 0 0-.641.641v4.275h3.511v-4.275A.641.641 0 0 0 13 16.5z",
    class: "cls-1",
    transform: "translate(-.549 -.907)"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };